import { create } from "zustand";

export type VariableInput = {
  key: string;
  value: string;
  prefix?: string;
  group: string;
  disabled?: boolean;
};

export const constructVariableString = (value: VariableInput) => {
  return value.prefix ? `${value.prefix}.${value.value}` : value.value;
};

type VariableInputStore = {
  variables: VariableInput[];
  setVariables: (variables: VariableInput[]) => void;
  appendVariables: (variables: VariableInput[]) => void;
};

export const useVariableInputStore = create<VariableInputStore>((set) => ({
  variables: [],
  setVariables: (variables: VariableInput[]) => set(() => ({ variables })),
  appendVariables: (variables: VariableInput[]) => {
    return set((state) => {
      const combinedVariables = [...state.variables, ...variables];
      const removeDuplicateVars = combinedVariables.filter(
        (variable, index, self) =>
          index ===
          self.findIndex(
            (t) =>
              constructVariableString(variable) === constructVariableString(t),
          ),
      );
      return {
        variables: removeDuplicateVars,
      };
    });
  },
}));
